import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import {Tooltip} from "primereact/tooltip";
import {ProgressBar} from "primereact/progressbar";
import currencyFormatter from "currency-formatter";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";

const _FM_FolioListComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [folio, setFolio] = useState([]);
  const [selectedFolios, setSelectedFolios] = useState([]);
  const [selectedFolioAccommodation, setSelectedFolioAccommodaton] = useState(null);
  const [reservationGroups, setReservationGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('folio_first')) || 0,
    rows: Number(localStorage.getItem('folio_rows')) || rows,
    page: Number(localStorage.getItem('folio_page')) || 0,
    sortField: localStorage.getItem('folio_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('folio_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('folio_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if (props.customerId) {
        query += '&search[customer][operator]=%3D&search[customer][value]=' + props.customerId
      }
      if (props.reservationGroupId) {
        query += '&search[reservation_group][operator]=%3D&search[reservation_group][value]=' + props.reservationGroupId
      }
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "folio" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setFolio(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', folioSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', folioSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if (window.location.hash.toString().includes('#/folio')) {
                    navigate('/folio/read/' + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/customer')) {
                    navigate('/customer/' + action + '/' + id + '?read=folio&folioId=' + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/reservation')) {
                    navigate('/reservation/' + action + '/' + id + '?read=folio&folioId=' + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/calendar')) {
                    navigate('/calendar/' + action + '/' + id + '?read=folio&folioId=' + rowData.id)
                  }
                }}/>
        {action !== 'read' &&
          <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-ml-2"
                  tooltip={t('edit')}
                  disabled={rowData.invoiced}
                  tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/folio')) {
                      navigate('/folio/update/' + rowData.id)
                    }
                    if (window.location.hash.toString().includes('#/customer')) {
                      navigate('/customer/' + action + '/' + id + '?update=folio&folioId=' + rowData.id)
                    }
                    if (window.location.hash.toString().includes('#/reservation')) {
                      navigate('/reservation/' + action + '/' + id + '?update=folio&folioId=' + rowData.id)
                    }
                    if (window.location.hash.toString().includes('#/calendar')) {
                      navigate('/calendar/' + action + '/' + id + '?update=folio&folioId=' + rowData.id)
                    }
                  }}/>
        }
        <Button icon="pi pi-file" className="p-button-sm  p-button-success p-ml-2"
                tooltip={t('new_receipt_from_folio')}
                disabled={rowData.invoiced}
                tooltipOptions={{position: 'left'}}
                onClick={async () => {
                  setLoading(true)
                  let _items = []
                  try {
                    const response = await axios({
                      method: 'get',
                      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                        + "folio-item?search[folio][operator]=%3D&search[folio][value]=" + rowData.id,
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                        "Sys-name": Cookies.get("instanceId"),
                        "Preferred-locale": Cookies.get("language")
                      }
                    })
                    _items = (response.data.data.items ?? [])
                      .filter(item => item?.invoiced !== true && item?.on_invoice !== true)
                      .map(item => item.id)
                    setLoading(false)
                  } catch (error) {
                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                    setLoading(false)
                    return;
                  }
                  if (window.location.hash.toString().includes('#/folio')) {
                    navigate('/folio?create=invoice&folioItemIds=' + _items + '&folioIds=' + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/customer')) {
                    navigate('/customer/' + action + '/' + id + '?create=invoice&folioItemIds=' + _items + '&folioIds=' + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/reservation')) {
                    navigate('/reservation/' + action + '/' + id + '?create=invoice&folioItemIds=' + _items + '&folioIds=' + rowData.id)
                  }
                  if (window.location.hash.toString().includes('#/calendar')) {
                    navigate('/calendar/' + action + '/' + id + '?create=invoice&folioItemIds=' + _items + '&folioIds=' + rowData.id)
                  }
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('folio_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('folio_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('folio_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('folio_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('folio_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('folio_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation-group",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setReservationGroups(response.data.data.items)
      })
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderFolioList])

  return (
    <>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: 'absolute', top: 0, zIndex: 9}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-3 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('folio_list')}</h2>
        </div>
        <div className={"p-col-12 p-lg-9 p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          <Button type="button" label={t('folios_manage')} icon={"pi pi-table"}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/folio')) {
                      navigate('/folio/manage?folioIds=' + selectedFolios.map(folio => folio.id).join(','))
                    }
                    if (window.location.hash.toString().includes('#/customer')) {
                      navigate('/customer/' + action + '/' + id + '?manage=folio&folioIds=' + selectedFolios.map(folio => folio.id).join(','))
                    }
                    if (window.location.hash.toString().includes('#/reservation')) {
                      navigate('/reservation/' + action + '/' + id + '?manage=folio&folioIds=' + selectedFolios.map(folio => folio.id).join(','))
                    }
                    if (window.location.hash.toString().includes('#/calendar')) {
                      navigate('/calendar/' + action + '/' + id + '?manage=folio&folioIds=' + selectedFolios.map(folio => folio.id).join(','))
                    }
                  }}
                  disabled={!selectedFolios[0]}
                  className="p-button-warning p-ml-2"/>
          {localStorage.getItem('folio_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('folio_filters')
                 localStorage.removeItem('folio_sortField')
                 localStorage.removeItem('folio_sortOrder')
                 localStorage.removeItem('folio_rows')
                 localStorage.removeItem('folio_page')
                 localStorage.removeItem('folio_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          {!props.customerId &&
            <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('folio_filters')
                             localStorage.removeItem('folio_sortField')
                             localStorage.removeItem('folio_sortOrder')
                             localStorage.removeItem('folio_rows')
                             localStorage.removeItem('folio_page')
                             localStorage.removeItem('folio_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
          }
          <Button type="button" label={t('new_folio')} icon={"pi pi-plus"}
                  onClick={() => {
                    if (window.location.hash.toString().includes('#/customer')) {
                      navigate('/customer/' + action + '/' + id + '?create=folio')
                    } else if (window.location.hash.toString().includes('#/reservation')) {
                      navigate('/reservation/' + action + '/' + id + '?create=folio')
                    } else if (window.location.hash.toString().includes('#/calendar')) {
                      navigate('/calendar/' + action + '/' + id + '?create=folio')
                    } else {
                      navigate('/folio/create')
                    }
                  }}
                  className="p-button-success p-ml-2"/>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"folio"}/> */}
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={folio} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selection={selectedFolios}
        onSelectionChange={(e) => {
          if (e.value && e.value[0]) {
            setSelectedFolioAccommodaton(e.value[0].accommodation.id)
          } else {
            setSelectedFolioAccommodaton(null)
            setSelectedFolios([])
          }
          if (selectedFolioAccommodation === null || selectedFolioAccommodation === e.value[e.value.length - 1]?.accommodation.id) {
            setSelectedFolios(e.value)
          } else {
            if (e.value.length > 1) {
              window.App.customToastShow('warn', t('warning'), t('folio_not_selectable_multiple_accommodations'), '', '');
            }
          }
        }}
        onRowDoubleClick={(rowData) => {
          if (!rowData.data.deleted_at_snapshot && rowData.data.invoiced != true) {
            if (window.location.hash.toString().includes('#/folio')) {
              navigate('/folio/update/' + rowData.data.id)
            }
          }
        }}
      >
        <Column selectionMode="multiple" headerStyle={{width: '3rem'}} headerClassName={'hide-checkbox'}></Column>
        <Column field="name" sortable header={t('name')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                body={(rowData) => {
                  return (
                    <>
                      {/*<span className={"tooltip-" + rowData.id}>*/}
                      {/*  <i className={"pi pi-info-circle p-mr-2"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>*/}
                      {/*</span>*/}
                      {rowData.name}
                      {/*<Tooltip target={".tooltip-" + rowData.id}>*/}
                      {/*  {t('folio')}: {rowData.id}*/}
                      {/*</Tooltip>*/}
                    </>
                  )
                }}
        ></Column>
        {!props.reservationGroupId &&
          <Column field="accommodation.name" sortable header={t('accommodation')}
                  body={(rowData) => {
                    const autoInvoiceTooltipId = "tt-auto-invoice-" + rowData.id;
                    return (
                      <>
                        <span className={"p-text-nowrap"}>
                          {rowData?.accommodation?.name}
                          <span
                            id={autoInvoiceTooltipId}
                            className={"p-ml-2"}
                            data-pr-tooltip={rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"auto-invoice-icon"} style={{ color: rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd', position: 'relative', bottom: '-3px' }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8" /><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1" /><path d="M9 7h6" /><path d="M9 11h4" /><path d="M18 14a3 3 0 1 0 3 3" /><path d="M21 20v-3h-3" /></svg>
                          </span>
                        </span>
                        <Tooltip target={"#" + autoInvoiceTooltipId}/>
                      </>
                    )
                  }}
          ></Column>
        }
        {!props.customerId && !props.reservationGroupId &&
          <Column header={t('reservation') + " / " + t('guest')} sortable
                  body={(rowData) => {
                    if (!window.App.urlVars().entity && rowData?.customer?.id) {
                      return (
                        <>
                          {window.location.href.includes('#/folio') &&
                            <>
                              <i className={"pi pi-window-maximize"}
                                 onClick={(e) => {
                                   navigate('/folio/' + '?update=customer&customerId=' + rowData.customer?.id)
                                 }}
                              ></i>
                              &nbsp;
                            </>
                          }
                          {rowData?.customer?.lastname} {rowData?.customer?.firstname}
                        </>
                      )
                    }
                    if (rowData.reservation_group?.id) {
                      return (
                        <>
                          {window.location.href.includes('#/folio') &&
                            <>

                              <i className={"pi pi-window-maximize"}
                                 onClick={(e) => {
                                   navigate('/folio/' + '?read=reservationGroup&reservationGroupId=' + rowData.reservation_group?.id)
                                 }}
                              ></i>
                              &nbsp;
                            </>
                          }
                          {rowData.reservation_group?.public_id.toUpperCase()}
                        </>
                      )
                    }
                  }}
          ></Column>
        }
        <Column field="net_amount" sortable header={t('net_amount')}
                filter
                filterMatchMode="equals"
                filterMatchModeOptions={filterNumberMatchModes}
                className={"p-text-right p-text-nowrap"}
                body={(rowData) => {
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.net_amount, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )}
                      &nbsp;{rowData.currency}
                    </>
                  )
                }}
        ></Column>
        <Column field="vat" sortable header={t('vat')}
                filter
                filterMatchMode="equals"
                filterMatchModeOptions={filterNumberMatchModes}
                className={"p-text-right p-text-nowrap"}
                body={(rowData) => {
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.vat_amount, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )}
                      &nbsp;{rowData.currency}
                    </>
                  )
                }}
        ></Column>
        <Column field="gross_amount" sortable header={t('gross_amount')}
                filter
                filterMatchMode="equals"
                filterMatchModeOptions={filterNumberMatchModes}
                className={"p-text-right p-text-nowrap"}
                body={(rowData) => {
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.gross_amount, {
                          precision: t('currency_precision'),
                          symbol: t('currency_symbol'),
                          decimal: t('currency_decimal'),
                          thousand: t('currency_thousand'),
                        }
                      )}
                      &nbsp;{rowData.currency}
                    </>
                  )
                }}
        ></Column>
        <Column field="invoiced" header={t('invoiced')} sortable className={"p-text-left"} body={(rowData) => {
          return (
            <>
              {rowData.invoiced === true ? (
                <>
                  <i className={"pi pi-check text-success p-mr-2"}></i>
                  {rowData.invoiced_at !== null &&
                    <>
                      {moment.utc(rowData.invoiced_at).local().format(t('YYYY-MM-DD HH:mm:ss'))}
                    </>
                  }
                </>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}
        ></Column>
        {!props.customerId && !props.reservationGroupId &&
          <Column field="created_at_snapshot" sortable header={t('created_at')}
                  filter
                  filterField={"created_at"}
                  sortField={"created_at"}
                  filterMatchMode="between"
                  filterMatchModeOptions={filterDateMatchModes}
                  body={(rowData) => {
                    if (rowData.created_at_snapshot !== null) {
                      return (
                        <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                      )
                    }
                  }}></Column>
        }
        <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.updated_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_FolioListComponent);
